import { render } from "./GamesOverview.vue?vue&type=template&id=4b51d460&ts=true"
import script from "./GamesOverview.vue?vue&type=script&lang=ts"
export * from "./GamesOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__